import { gql } from '@grandvisionhq/graphql';

const orderShippingInfo = gql`
  fragment OrderShippingInfoFragment on OrderShippingInfo {
    deliveryMethodName
    expectedDeliveryEstimation {
      ... on DateEstimation {
        deliveryDate
      }
      ... on RangeEstimation {
        deliveryRange {
          min
          max
        }
      }
    }
  }
`;

export { orderShippingInfo };
//# sourceMappingURL=order-shipping-info.js.map
